module.exports = __webpack_public_path__ + "img/product_icon.29dddcda.png";